<script lang="ts">
    import { onMount } from 'svelte';
    import LegalNotice from '../../components/LegalNotice.svelte';
    import { addClassName } from '../../helpers';

    onMount(() => addClassName())
</script>

<div class="container">
    <LegalNotice />
</div>